<template>
<div>
    <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="120px" class="demo-editForm">
        <el-form-item label="图文详情" label-width="100px" prop="storeGoodsGraphic">
            <tinymce-editor v-model="editForm.storeGoodsGraphic" :type="4"  @change="changes"></tinymce-editor>
        </el-form-item>
       <div style="text-align:center;padding-top: 20px">
            <el-button type="primary" @click="prev()">上一步</el-button>
            <el-button type="primary" @click="saveAndNext('editForm')">保存</el-button>
       </div>
    </el-form>
</div>
</template>

<script>
    import VploadImg from "../../inc/VploadImg";
    import TinymceEditor from "../../inc/TinymceEditor";
    export default {
        name: "GraphicDetails",
        components:{
          VploadImg,TinymceEditor
        },
        props:{
            storeGoodsId:{
                type:Number,
            },
            storeGoodsGraphic:[]
        },
        data(){
            return{
                editForm:{},
                fileList:[],
                // totalCartons:0,
                ispostage:false,
                getTagvisible:false,
                editFormRules: {
                    storeGoodsGraphic: [
                        {required: true, message: '请输入单品图文详情', trigger: 'blur'}
                    ],
                },
            }
        },
        watch:{
            storeGoodsId(n,o){ //n为新值,o为旧值;
                this.storeGoodsId=n
                console.log('新增1',n)
                console.log('旧知1',o)
                // console.log("wwwwwwwaqaaqqq")
                // if (n&&n!=0){
                //     this.getStoreGoodsInfo(n)
                // }else {
                //     this.editForm={}
                //     this.fileList=[]
                // }
            }
        },
        mounted() {
        },
        created() {
            if (this.storeGoodsId){
                this.getStoreGoodsInfo(this.storeGoodsId)
            }else {
                this.editForm={}
                this.fileList=[]
            }
        },

        methods:{
             changes(val) {
                this.editForm.storeGoodsGraphic=val;
            },
            resetForm(formName) {
                //
                this.editForm = {}
                this.fileList=[];
                //this.storeGoodsId=undefined
            },

            handleClose() {
                this.resetForm('editForm')
            },
            getImgList(url,add) {
                if (add==1){
                    this.editForm.storeGoodsCover=url
                }else if (add==0){
                    this.editForm.storeGoodsCover='';
                }
            },
            getStoreGoodsInfo(id){
                this.$axios.post('/admin/singleStoreGoods/getSingleStoreGraphicInfo' ,{storeGoodsId:id}).then(res => {
                    if (res.data){
                        this.editForm = res.data
                    }
                })
            },
             // 上一步
            prev() {
                console.log(22222)
                this.$emit("changeComponent1Data", -1)
            },
            //   保存并下一步
            saveAndNext(formName) {
                this.$refs[formName].validate((valid) => {
                    console.log('valid',valid)
                    if (valid) {
                        // if (this.editForm.totalCartons>1000){
                        //     this.$message({
                        //         showClose: true,
                        //         message: '商品箱子数不不可以超1000',
                        //         type: 'error',
                        //     });
                        //     return ;
                        // }
                        // if (this.editForm.totalCartons<this.totalCartons){
                        //     this.$message({
                        //         showClose: true,
                        //         message:'箱子数不可以变小',
                        //         type: 'error',
                        //     });
                        //     return ;
                        // }
                        this.editForm.storeGoodsId=this.storeGoodsId
                        this.$axios.post('/admin/singleStoreGoods/addSingleStoreGraphic' , this.editForm)
                            .then(res => {
                                if (!this.editForm.storeGoodsId){
                                    this.editForm=res.data
                                    this.storeGoodsId=res.data.storeGoodsId
                                    this.$parent.$parent.storeGoodsId=res.data.storeGoodsId
                                }
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，操作成功',
                                    type: 'success',
                                    onClose:() => {
                                        // this.$emit("changeComponent1Data", 1)
                                        this.$parent.handleClose()
                                        this.$parent.$parent.getStoreGoods()
                                    }
                                });
                            })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
